export default __webpack_public_path__ + "static/media/background-asset.eb86213c.svg";